import { render, staticRenderFns } from "./ModalSelectReminder.vue?vue&type=template&id=1c8ffa3a&"
import script from "./ModalSelectReminder.vue?vue&type=script&lang=js&"
export * from "./ModalSelectReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports